import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const LoginSchema = Yup.object().shape({
  username: Yup.string()
    .min(3, 'Username must be at least 3 characters')
    .required('Username is required'),
  password: Yup.string()
    .min(6, 'Password must be at least 6 characters')
    .required('Password is required'),
});

const Login = () => {
  const navigate = useNavigate();
  const [loginError, setLoginError] = useState('');

  const handleSubmit = (values, { setSubmitting }) => {
    setLoginError('');
    
    // Simulate login logic
    setTimeout(() => {
      // Replace this with actual authentication logic
      if (values.username && values.password) {
        console.log('Login successful', values);
        // Store auth token or user data here
        localStorage.setItem('isAuthenticated', 'true');
        navigate('/dashboard');
      } else {
        setLoginError('Invalid credentials. Please try again.');
      }
      setSubmitting(false);
    }, 1000);
  };

  return (
    <div className="login-container">
      <div className="container">
        <div className="row justify-content-center align-items-center min-vh-100">
          <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
            <div className="card shadow-lg">
              <div className="card-body p-4 p-sm-5">
                <div className="text-center mb-4">
                  <h2 className="fw-bold text-primary">KPM-Trizent Tab App</h2>
                  <p className="text-muted">Sign in to your account</p>
                </div>

                {loginError && (
                  <div className="alert alert-danger" role="alert">
                    {loginError}
                  </div>
                )}

                <Formik
                  initialValues={{ username: '', password: '' }}
                  validationSchema={LoginSchema}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting, errors, touched }) => (
                    <Form>
                      <div className="mb-3">
                        <label htmlFor="username" className="form-label">
                          Username
                        </label>
                        <Field
                          type="text"
                          name="username"
                          className={`form-control ${
                            errors.username && touched.username ? 'is-invalid' : ''
                          }`}
                          placeholder="Enter your username"
                        />
                        <ErrorMessage
                          name="username"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>

                      <div className="mb-4">
                        <label htmlFor="password" className="form-label">
                          Password
                        </label>
                        <Field
                          type="password"
                          name="password"
                          className={`form-control ${
                            errors.password && touched.password ? 'is-invalid' : ''
                          }`}
                          placeholder="Enter your password"
                        />
                        <ErrorMessage
                          name="password"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>

                      <div className="d-grid">
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Signing in...
                            </>
                          ) : (
                            'Sign In'
                          )}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>

                <div className="text-center mt-4">
                  <small className="text-muted">
                    © 2024 Trizent. All rights reserved.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
